import { hasActiveSubscription } from "@/application/helpers/check-subscription";
import { NotFoundPage } from "@/interface/pages/not-found-page";
import PageLoader from "@/interface/pages/page-loader";
import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";

function handleUnauthorizedAccess(location?: string) {
  throw redirect({
    to: "/users/subscription/plans",
    search: {
      from: location,
    },
  });
}

export const Route = createFileRoute("/_authenticated/_active-subscription")({
  component: LayoutComponent,
  notFoundComponent: NotFoundPage,
  staleTime: Infinity, // Keep the data cached for the lifetime of the app
  loader: async () => {
    const validSubscription = await hasActiveSubscription();
    if (!validSubscription) {
      throw redirect({
        to: "/users/subscription/plans",
      });
    }
  },
  pendingComponent: PageLoader,
  onError: () => handleUnauthorizedAccess(),
});

function LayoutComponent() {
  return <Outlet />;
}
